export const commissions = {
  by_affiliate: {
    STANDARD: {
      name: 'STANDARD',
      oneShot_commission: 0.3,
      recurring_commission: 0,
    },
    BRONZE: {
      name: 'BRONZE',
      oneShot_commission: 0.3,
      recurring_commission: 0.2,
    },
    SILVER: {
      name: 'SILVER',
      oneShot_commission: 0.4,
      recurring_commission: 0.3,
    },
    GOLD: {
      name: 'GOLD',
      oneShot_commission: 0.5,
      recurring_commission: 0.3,
    },
  },
  for_contributor: {
    STANDARD: {
      name: 'STANDARD',
      oneShot_amount: 0,
      recurring_amount: 0,
    },
    BRONZE: {
      name: 'BRONZE',
      oneShot_amount: 1,
      recurring_amount: 0,
    },
    SILVER: {
      name: 'SILVER',
      oneShot_amount: 2,
      recurring_amount: 1,
    },
    GOLD: {
      name: 'GOLD',
      oneShot_amount: 5,
      recurring_amount: 2,
    },
  },
  plans: {
    min_price_plan: 19,
    max_price_plan: 3588,
  },
};
